import { makeStyles } from '@material-ui/core';
import { distances } from '../../../styles';

export const useSQuadrantStyles = makeStyles(({ spacing }) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1
  },
  grid: {
    flexGrow: 1,
    height: '100%',
    display: 'flex',
    padding: distances.base,
    paddingTop: 0
  },
  gridItem: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    minHeight: 0
  },
  left: {
    paddingRight: distances.base
  },
  right: {
    paddingLeft: distances.base
  },
  order2: {
    order: 2
  },
  topConatiner: {
    padding: spacing(2),
    width: '100%',
    height: 75,
    display: 'flex',
    alignItems: 'center'
  },
  bottomContainer: {
    position: 'relative',
    height: 100,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flexGrow: 1,
    minHeight: '0%'
  }
}));
